/* eslint-disable no-underscore-dangle */
import { App } from '@grafikr/components';
import type { LineItem } from '@grafikr/shopify-typescript/type/json/LineItem';
import { differenceInSeconds } from 'date-fns';
import formatMoney from 'utils/format-money';

const PAGE_VISITS_KEY = 'page_visits';
const HAS_SCROLLED_ENOUGH_KEY = 'has_scrolled_enough';
const PRODUCT_VISITS_COUNTER_KEY = 'products_visited';

const tracking = ({ emitter }: App) => {
  window.dataLayer = window.dataLayer ?? [];
  window._learnq = window._learnq ?? [];

  // Register information about session
  const sessionTracking = () => {
    const pageVisits: string[] = JSON.parse(sessionStorage.getItem(PAGE_VISITS_KEY) ?? '[]');
    pageVisits.push(new Date().toISOString());

    sessionStorage.setItem(PAGE_VISITS_KEY, JSON.stringify(pageVisits));

    const getSessionTime = () => {
      const visits = JSON.parse(sessionStorage.getItem(PAGE_VISITS_KEY) ?? '[]');

      if (visits.length < 2) {
        return 0;
      }

      return differenceInSeconds(new Date(visits.at(-1)), new Date(visits.at(0)));
    };

    const checkIfHighQualityVisitor = () => {
      const sessionTime = getSessionTime();
      const productHits = parseInt(sessionStorage.getItem(PRODUCT_VISITS_COUNTER_KEY) ?? '0', 10);
      const hasScrolledEnough = sessionStorage.getItem(HAS_SCROLLED_ENOUGH_KEY) === 'yes';

      if (sessionTime >= 45 && productHits >= 2 && hasScrolledEnough) {
        window.dataLayer.push({ event: 'high_quality_visitor' });

        if (window.fbq) {
          window.fbq('trackCustom', 'HighQualityVisitor');
        }
      }
    };

    if (theme.currentPageType === 'product') {
      let visits = parseInt(sessionStorage.getItem(PRODUCT_VISITS_COUNTER_KEY) ?? '0', 10);
      visits += 1;

      sessionStorage.setItem(PRODUCT_VISITS_COUNTER_KEY, visits.toString());
    }

    if (!sessionStorage.getItem(HAS_SCROLLED_ENOUGH_KEY)) {
      const scrollEvent = () => {
        const totalPageHeight = document.body.scrollHeight - window.innerHeight;

        if (window.scrollY >= totalPageHeight * 0.5) {
          sessionStorage.setItem(HAS_SCROLLED_ENOUGH_KEY, 'yes');
          window.removeEventListener('scroll', scrollEvent);

          checkIfHighQualityVisitor();
        }
      };

      window.addEventListener('scroll', scrollEvent, { passive: true });
    }

    checkIfHighQualityVisitor();
  };
  sessionTracking();

  // Klaviyo: Added to cart event
  emitter.on('cart:added', (body: LineItem) => {
    const structuredData = {
      Brand: body.vendor,
      CompareAtPrice: formatMoney(0).toString(),
      ImageURL: body.image,
      Name: body.title,
      Price: formatMoney(body.price).toString(),
      ProductID: body.product_id,
      ProductURL: `https://${window.theme.domain}${body.url.split('?')[0]}`,
    };

    const data = window.theme.handle === body.handle && window.item ? window.item : structuredData;
    window._learnq.push(['track', 'Added to Cart', data]);
  });
};

export default tracking;
